// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__37hb2","rootSmall":"AddTileButton_rootSmall__1fZ2y"};